<template>
    <div
        :class="[
            images ? 'mt-5' : ''
        ]"
    >
        <slot name="top" :data="images" />
        <div class="relative">
            <div class="absolute z-10 flex transform inset-0 items-center justify-center bg-gray-100 bg-opacity-40"
                v-if="loading && spinner"
            >
                <Spinner class="w-20 h-20" />
            </div>
            <Draggable
                class="grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 gap-2 mb-5"
                item-key="id"
                tag="transition-group"
                :component-data="{
                    tag: 'ul',
                    name: 'flip-list',
                    type: 'transition'
                }"
                v-model="images"
                v-if="images && images.length"
                v-bind="{ ghostClass: 'opacity-20' }"
                @change="changeAndSend()"
            >
                <template #item="{ element }">
                    <li
                        class="cursor-grab relative transition duration-500"
                        :class="[
                            type == 'gallery' ? 'rounded-md bg-gray-100 overflow-hidden p-2 border h-60' : 'border rounded-md flex justify-center hover:border-gray-400 hover:shadow-md group'
                        ]"
                    >
                        <div class="absolute top-1 right-1 group-hover:text-gray-400 text-gray-200">
                            <SvgIcon
                                name="x-circle"
                                class=" text-red-600 opacity-50 hover:text-red-700 hover:opacity-100 cursor-pointer rounded-full"
                                width="22"
                                height="22"
                                @click="removeImage(element.id, element)"
                            />
                        </div>
                        <img
                            :class="[
                                type == 'gallery' ? 'w-full h-full object-center object-cover' : 'max-h-28'
                            ]"
                            :src="(autosave || element.link) ? element.link : element.imageBase64"
                        >
                    </li>
                </template>
            </Draggable>
        </div>

        <div>
            <form @submit.prevent="upload_images" enctype="multipart/form-data" method="post">
                <label
                    for="file"
                    class="group w-full h-full py-4 px-2 border-2 border-dashed border-gray-300 hover:border-gray-400 rounded-md text-gray-300 hover:text-gray-400 flex justify-center items-center cursor-pointer transition duration-300"
                >
                    <SvgIcon
                        name="plus-circle"
                        width="36"
                        height="36"
                    />
                </label>
                <input
                    type="file"
                    @input="imagesUpload = $event.target.files"
                    class="hidden"
                    id="file"
                    name="filess"
                    :multiple="multiple"
                    @change="upload_images"
                />
            </form>

        </div>
    </div>
</template>

<script>
import SvgIcon from 'UI/SvgIcon';
import { ref } from 'vue';
import Draggable from 'vuedraggable'
import { Inertia } from '@inertiajs/inertia';
import Spinner from 'UI/Spinner';
import { usePage } from '@inertiajs/inertia-vue3';

export default {
    components: {
        SvgIcon,
        Draggable,
        Spinner,
    },
    props: {
        images: Object,
        autosave: Boolean,
        variation: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: true,
        },
        format: {
            type: String,
            default: 'file'
        },
        spinner: {
            type: Boolean,
            default: true,
        },
        routeLinks: [String, Array, Object],
        type: String,
        modelValue: [Object, Array]
    },
    emits: ['imagesUploaded', 'update:modelValue'],
    setup (props, {emit}) {
        const
            images = ref(props.images ? props.images : []),
            imagesUpload = ref([]),
            loading = ref(false);


        const upload_images = () => {
            loading.value = true;
            Array.from(imagesUpload.value).forEach((file, key) => {
                var approvedHTML = null;

                var filesize = ((file.size / 1024 ) / 1024).toFixed(4); // MB

                if (file.name != "item" && typeof file.name != "undefined" && filesize >= 10) {
                    let message = '';

                    message += app.__('Size of this image is to big!', null, usePage().props.value.profile_locale);
                    message += "\n\n" + app.__('Title', null, usePage().props.value.profile_locale) + ': ' + file.name;
                    message += "\n" + app.__('Size', null, usePage().props.value.profile_locale) + ': ' + filesize;
                    message += "\n" + app.__('Max size', null, usePage().props.value.profile_locale) + ': 10 Mb';

                    alert(message);
                }
                else getImageInBase64(file, key);
            });
        }

        const removeImage = (id, image) => {
            loading.value = true;
            let key = images.value.map(function(e) { return e.id; }).indexOf(id);

            if(props.autosave || props.type == 'gallery'){
                // remove server side
                Inertia.post(route(props.type == 'gallery' ? 'remove.gallery' : (props.routeLinks ? props.routeLinks.remove : 'remove.product.image')), {
                    image: image,
                },
                {
                    preserveScroll: true,
                    onSuccess: () => {
                        images.value = props.images,
                        loading.value = false;
                    },
                })
            }
            else {
                // remove client side
                images.value.splice(key, 1);
                changeAndSend();
            }
        }

        // Functions
        function getImageInBase64(image, key) {

            var FR = new FileReader();

            FR.addEventListener("load", function(e) {
                let max = 0;
                if(images.value.length)
                    max = images.value.reduce((max, obj) => (max.id > obj.id) ? max : obj);

                let values = {
                    id: images.value.length > 0 ? Number(max.id) + 1 : Number(key) + 1,
                };

                if(props.format == 'file') values['image'] = image;
                else values['image'] = e.target.result;

                values['imageBase64'] = e.target.result;

                images.value.push(values);

                if(imagesUpload.value.length == key + 1) {
                    changeAndSend(props.autosave ? 'upload' : 'change');
                }
            });
            FR.readAsDataURL( image );
        }

        function changeAndSend(ev = 'change') {
            let arr = [];
            let files = {};
            images.value.forEach((el, key) => {
                arr.push(Number(key) + 1);
                files['file_' + (key + 1)] = el.image;
            });

            if(!props.autosave){
                if(props.routeLinks && props.routeLinks.change) {
                    Inertia.post(route(props.routeLinks.change), {
                        image: images.value,
                        files: files,
                    }, {
                        preserveScroll: true,
                        onSuccess: () => {
                            images.value = props.images,
                            loading.value = false
                        },
                    });
                }
                else {
                    emit(props.modelValue ? 'update:modelValue' : 'imagesUploaded', {
                        image: props.type == 'gallery' || props.type == 'links' ? images.value : arr,
                        files: files,
                    });

                    loading.value = false;
                }
            }
            else if(props.type != 'gallery') {

                Inertia.post(route('upload.images'), {
                    type: ev,
                    option: arr,
                    images: images.value,
                    files: files,
                    product_id: route().params.product
                }, {
                    preserveScroll: true,
                    onSuccess: () => {
                        images.value = props.images,
                        loading.value = false;
                    },
                })
            }
            else loading.value = false;
        }


        return {
            images,
            imagesUpload,
            loading,

            changeAndSend,
            upload_images,
            removeImage,
            getImageInBase64,
        }
    },
}
</script>
<style>
.flip-list-move {
  transition: transform 0.5s;
}
</style>
